module.exports = __webpack_public_path__ + "TaniyaDas-d13a30b7.png";